import Phaser from 'phaser'
import { Foreground } from '../base/foreground'
import { NEON_LIGHT_TEXTURE_KEYS, NEON_LIGHTS_ATLAS_FRAMES } from './constants'

export class NeonLightsForeground extends Foreground {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  createForeground() {
    const foreground = this.scene.add.image(
      this.scene.cameras.main.centerX,
      this.scene.cameras.main.centerY + 10,
      NEON_LIGHT_TEXTURE_KEYS.ATLAS,

      NEON_LIGHTS_ATLAS_FRAMES.FOREGROUND,
    )
    foreground.setOrigin(0.5, 0.5)

    this.add(foreground)
  }
}
